import { render, staticRenderFns } from "./SliderCourses.vue?vue&type=template&id=1675da30&scoped=true&"
import script from "./SliderCourses.vue?vue&type=script&lang=js&"
export * from "./SliderCourses.vue?vue&type=script&lang=js&"
import style0 from "./SliderCourses.vue?vue&type=style&index=0&id=1675da30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675da30",
  null
  
)

export default component.exports